import { NumericFormat } from "react-number-format";
import React from "react";

export const NumericFormatAdapter = React.forwardRef(function NumericFormatAdapter(props, ref) {
	const { onChange, name, formatSpec = {}, ...other } = props;
	const {
		kind = "number", // "currency" | "percentage" | "number"
		symbol = "", // e.g., "$"
		unit = "", // e.g., "USD"
		decimals = 2, // decimal places
		fixed = true, // keep trailing zeros for currencies
		allowNegative = true,
		min,
		max,
	} = formatSpec;

	return (
		<NumericFormat
			{...other}
			// react-number-format supports a customInput prop, so callers can render
			// formatted numeric fields through a real design-system input component
			// (for example @metrea-ui/v2 Input) without losing the raw numeric-string
			// onChange contract this adapter preserves for existing RAVEN screens.
			getInputRef={ref}
			valueIsNumericString
			thousandSeparator
			allowNegative={allowNegative}
			decimalScale={decimals}
			fixedDecimalScale={fixed}
			isAllowed={(values) => {
				const { value, floatValue } = values;
				if (value === "") return true;
				if (floatValue == null) return false;
				if (min != null && floatValue < min) return false;
				if (max != null && floatValue > max) return false;
				return true;
			}}
			prefix={kind === "currency" ? (symbol ? `${symbol} ` : "") : undefined}
			suffix={
				kind === "percentage"
					? " %"
					: kind === "currency" && unit
						? ` ${unit}`
						: undefined
			}
			onValueChange={(v, sourceInfo) => onChange?.({ target: { name, value: v.value } }, sourceInfo)}
		/>
	);
});
